/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type CreateMarginOfferMutationVariables = Types.Exact<{
	input: Types.CreateMarginOfferRequest;
}>;

export type CreateMarginOfferMutation = {
	__typename?: "Mutation";
	createMarginOffer: {
		__typename?: "CreateMarginOfferResponse";
		offerId: string;
		positionStatus: Types.PositionStatus;
		underlyingAssetId: string;
		tradeFiatId: string;
		amountAsset: string;
		dailyFee: string;
		price: string;
		amountInTradeUnit: string;
		amountInPairUnit: string;
		userJourney?: string | null;
		isFeeTransparent: boolean;
		isRemainingPositionDust: boolean;
		isTaxable: boolean;
		pairUnit: { __typename?: "UnitDefinitionResponse"; unitID: string; unitType: Types.UnitType };
		totalPosition: {
			__typename?: "Position";
			assetId: string;
			borrowedFundsInFiat: string;
			borrowedFundsInUnderlyingAsset: string;
			totalPositionInFiat: string;
			liquidationPriceInFiat: string;
			liquidationThresholdPercentage: string;
			healthIndicator: Types.MarginHealthIndicator;
			marginLevel: string;
			marginMinimum: string;
			marginMaximum: string;
			leverage: string;
			leverageDirection: Types.LeverageDirection;
		};
		positionChange?:
			| {
					__typename: "MarginPositionDecrease";
					decreasedPosition?: {
						__typename?: "DecreasedPosition";
						repayingFundsInUnderlyingAsset: string;
						repayingFundsInFiat: string;
						receivedFunds: string;
					} | null;
			  }
			| {
					__typename: "MarginPositionIncrease";
					addedPosition?: {
						__typename?: "IncreasedPosition";
						borrowedFundsInUnderlyingAsset: string;
						totalPositionInFiat: string;
						leverage: string;
					} | null;
			  }
			| null;
		fee?: {
			__typename?: "Fee";
			fiat: { __typename?: "FeeAmount"; value: string };
			asset: { __typename?: "FeeAmount"; value: string };
			net: { __typename?: "FeeAmount"; value: string };
			percentage: { __typename?: "FeePercentage"; value: string };
			priceWithoutFee: { __typename?: "FeeAmount"; value: string };
		} | null;
		tax?: {
			__typename?: "Tax";
			isTaxServiceAvailable: boolean;
			fiatId: string;
			assetId?: string | null;
			taxAmountFiat: { __typename?: "CurrencyAmount"; value: string };
			fiatAmountAfterTax?: { __typename?: "CurrencyAmount"; value: string } | null;
			taxAmountAsset?: { __typename?: "CurrencyAmount"; value: string } | null;
		} | null;
		expiresAt: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
		serverTime: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
	};
};

export const CreateMarginOfferDocument = gql`
	mutation createMarginOffer($input: CreateMarginOfferRequest!) {
		createMarginOffer(request: $input) {
			offerId
			positionStatus
			underlyingAssetId
			tradeFiatId
			amountAsset
			pairUnit {
				unitID
				unitType
			}
			totalPosition {
				assetId
				borrowedFundsInFiat
				borrowedFundsInUnderlyingAsset
				totalPositionInFiat
				liquidationPriceInFiat
				liquidationThresholdPercentage
				healthIndicator
				marginLevel
				marginMinimum
				marginMaximum
				leverage
				leverageDirection
			}
			positionChange {
				__typename
				... on MarginPositionIncrease {
					addedPosition {
						borrowedFundsInUnderlyingAsset
						totalPositionInFiat
						leverage
					}
				}
				... on MarginPositionDecrease {
					decreasedPosition {
						repayingFundsInUnderlyingAsset
						repayingFundsInFiat
						receivedFunds
					}
				}
			}
			dailyFee
			price
			amountInTradeUnit
			amountInPairUnit
			userJourney
			isFeeTransparent
			isRemainingPositionDust
			isTaxable
			fee {
				fiat {
					value
				}
				asset {
					value
				}
				net {
					value
				}
				percentage {
					value
				}
				priceWithoutFee {
					value
				}
			}
			tax {
				taxAmountFiat {
					value
				}
				isTaxServiceAvailable
				fiatId
				assetId
				fiatAmountAfterTax {
					value
				}
				taxAmountAsset {
					value
				}
			}
			expiresAt {
				iso8601
				unixTimestamp
			}
			serverTime {
				iso8601
				unixTimestamp
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class CreateMarginOfferGQLService extends Apollo.Mutation<
	CreateMarginOfferMutation,
	CreateMarginOfferMutationVariables
> {
	document = CreateMarginOfferDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
